module.exports = __webpack_public_path__ + "static/media/tti_save_time@3x.1c25e40a.png";